<template>
 <div class="productDetail">
    <slider :control-btn="false">
      <slider-item><img src="@/assets/images/banner_tianbao2.png" height="100%"></slider-item>
    </slider>
    <div class="module">
      <h1 class="title">产品介绍</h1>
      <div class="content">
        <div class="contentItem">
          <div class="subTitle">添葆中老年益酸菌高钙配方羊奶粉</div>
          <div class="fenjie"><img src="@/assets/images/ic_jiantou.png" ></div>
          <div class="describe">
            <p>添葆专注于中老年羊奶粉，旗下拥有添葆中老年益酸菌高钙配方羊奶粉，</p>
            <p>专注骨骼健康，倡导中老年人应该拥有活力健康的晚年生活。</p>
          </div>
          <img class="pic" src="@/assets/images/pic_chanpindatu.png" >
        </div>
        <div class="contentItem">
          <div class="subTitle">产品配料信息</div>
          <div class="fenjie"><img src="@/assets/images/ic_jiantou.png" ></div>
          <div class="describe">
            <p>生羊乳、低聚异麦芽糖、浓缩乳酸菌发酵原液、L-阿拉伯糖添加量30‰、低聚果糖、</p>
            <p>磷脂酰丝氨酸添加量2‰、植物甾醇酯添加量2‰、牛磺酸、动物双歧杆菌添加量≥1x108CFU/100g；</p>
            <p>复合维生素：醋酸视黄酯、dl-α-醋酸生育酚、胆钙化醇、L-抗坏血酸、盐酸吡哆醇、叶酸；</p>
            <p>矿物质：碳酸钙、硫酸亚铁、硫酸锌；</p>
            <p>蔗糖添加量为零。</p>
          </div>
          <img class="pic" src="@/assets/images/pic_yingyangchengfen.png" >
        </div>
        <div class="contentItem">
          <div class="subTitle">包装种类</div>
          <div class="fenjie"><img src="@/assets/images/ic_jiantou.png" ></div>
          <img class="pic" src="@/assets/images/pic_chanpinguige.png" >
        </div>
        <div class="contentItem">
          <div class="subTitle">生产厂商</div>
          <div class="fenjie"><img src="@/assets/images/ic_jiantou.png" ></div>
          <div class="describe">
            <p>陕西美力源乳业集团有限公司创建于2008年初，是集饲养、生产、销售一体的规模化、专业化的羊奶粉企业。</p>
            <p>2013年8月6日，美力源通过国家食药监总局婴幼儿配方乳粉生产企业检验。</p>
            <p>2015年，美力源乳业在蓝田县注册牧业公司，自建自控奶源基地，实行精细化管理。</p>
          </div>
          <img class="pic" src="@/assets/images/pic_zhengshu.png" >
        </div>
        <div class="contentItem">
          <div class="subTitle">奶源基地</div>
          <div class="fenjie"><img src="@/assets/images/ic_jiantou.png" ></div>
          <div class="describe">
            <p>添葆羊奶粉的奶源来自于美力源自建自控高山放养奶山羊奶源基地。</p>
            <p>在北纬34°秦岭北麓蓝田玉山镇打造专属奶源地。</p>
            <p>奶山羊每天清晨、下午放牧两次，羊群食百草尖，饮山涧泉水。</p>
          </div>
          <img class="pic" src="@/assets/images/pic_naiyuanyoushi.png" >
        </div>
        <div class="contentItem">
          <div class="subTitle">生产工艺</div>
          <div class="fenjie"><img src="@/assets/images/ic_jiantou.png" ></div>
          <div class="describe">
            <p>美力源奶粉工厂的空气经3级过滤净化，每批次奶粉从源头到成品检测项目千余项。</p>
            <p>在生产环节设置了11项关键控制节点，对微生物、温度、压力、杀菌时间等全方位管控。</p>
          </div>
          <img class="pic" src="@/assets/images/pic_gongchangshebei.png" >
        </div>
        <div class="contentItem">
          <div class="subTitle">专利技术</div>
          <div class="fenjie"><img src="@/assets/images/ic_jiantou.png" ></div>
          <div class="describe">
            <p>添葆中老年配方羊奶粉乳酸菌发酵工艺是陕西师范大学多位食品专家教授历经2年，多次实验，潜心研究的专利成果。</p>
            <p>该产品以多种乳酸菌菌种为基础，采用发酵型新工艺，增加了乳酸菌的数量，同时保持了乳酸菌的良好活性。</p>
          </div>
          <img class="pic zhuanlijishu" src="@/assets/images/pic_zhuanlijishu.png" >
        </div>
      </div>
    </div>
 </div>
</template>
<script>
import { Slider, SliderItem } from 'vue-easy-slider'

export default {
  name: 'productDetail',
  data () {
    return {
    }
  },
  components: {
    Slider,
    SliderItem
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='less' scoped>
.productDetail{
  .slider {
    width: 100% !important;
    height: 450px !important;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .module{
    padding: 96px 0 0px 0;
    .title{
      text-align: center;
      font-weight: normal;
      font-size: 26px;
      color:#333;
      background: url(../assets/images/line.png) bottom center no-repeat;
      padding-bottom: 36px;
      margin-bottom: 24px;
    }
    .contentItem{
      text-align: center;
      padding: 40px 0;
      .subTitle{
        text-align: center;
        font-size: 20px;
        color: #333333;
        font-weight: bold;
        padding-bottom:14px;
      }
      .fenjie{
        display: block;
        text-align: center;
        margin-bottom: 12px;
        line-height: 8px;
      }
      .describe{
        font-size: 16px;
        color:#333;
        padding-bottom: 14px;
        p{
          margin-bottom: 15px;
        }
      }
      .pic.zhuanlijishu{
        margin: 12px 0 20px 0;
      }
    }
    .contentItem:nth-child(2n){
      background-color: #fffaf2;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/productDetail.vue